/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhexternal11Inputs */

const en__field_enum_ikhexternal11 = /** @type {(inputs: _Field_Enum_Ikhexternal11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External Institution (not Goethe university)`)
};

const de__field_enum_ikhexternal11 = /** @type {(inputs: _Field_Enum_Ikhexternal11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe Institution (nicht Goethe Universität)`)
};

/**
* | output |
* | --- |
* | "External Institution (not Goethe university)" |
*
* @param {_Field_Enum_Ikhexternal11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhexternal11 = /** @type {((inputs?: _Field_Enum_Ikhexternal11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhexternal11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhexternal11(inputs)
	return de__field_enum_ikhexternal11(inputs)
});
export { _field_enum_ikhexternal11 as "_field_enum_IKHEXTERNAL" }